module.exports = __webpack_public_path__ + "img/async.0d39f0bd.png";